import { axiosPost } from "./ajaxServices";
import {
  urlGetShippingZoneList,
  urlCreateShippingZone,
  urlUpdateShippingZone,
  urlDeleteShippingZone,
} from "./CONSTANTS";

const config = { headers: { "content-type": "multipart/form-data" } };

export const apiGetShippingZoneList = () => {
  var formData = new FormData();
  return new Promise((resolve, reject) => {
    axiosPost(urlGetShippingZoneList, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const appendZoneFields = (formData, zone) => {
  formData.append("name", zone.name || "");
  formData.append("method_label", zone.method_label || zone.name || "");
  formData.append("countries", JSON.stringify(zone.countries || []));
  formData.append("packed_weight_factor", zone.packed_weight_factor ?? 0.75);
  formData.append("max_weight_g", zone.max_weight_g ?? 2000);
  if (zone.bracket_unit_id) formData.append("bracket_unit_id", zone.bracket_unit_id);
  formData.append("surcharge_enabled", zone.surcharge_enabled ? "1" : "0");
  formData.append("surcharge_label", zone.surcharge_label || "");
  formData.append("surcharge_amount", zone.surcharge_amount ?? 0);
  formData.append("status", zone.status ? "1" : "0");
  formData.append("brackets", JSON.stringify(zone.brackets || []));
};

export const apiCreateShippingZone = (zone) => {
  var formData = new FormData();
  appendZoneFields(formData, zone);
  return new Promise((resolve, reject) => {
    axiosPost(urlCreateShippingZone, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiUpdateShippingZone = (id, zone) => {
  var formData = new FormData();
  formData.append("id", id);
  appendZoneFields(formData, zone);
  return new Promise((resolve, reject) => {
    axiosPost(urlUpdateShippingZone, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiDeleteShippingZone = (id) => {
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(urlDeleteShippingZone, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};
